import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import inventoryHistoryModel from '@/models/inventory/inventory-history'
import inventoryPrivilegeCpcModel from '@/models/inventory/inventory-privilege-cpc'
import router from '@/router'
import store from '@/store'
import useDate from '@/utils/hooks/useDate'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import {
  computed,
  onBeforeMount,
  reactive,
  ref,
  watch,
} from '@vue/composition-api'
import { PRIVILEGE_TYPE } from '@/configs/privilege/privilege'

export default function useInventoryHistoryDetail() {
  const TAB_DETAIL = 'detail'
  const TAB_IMPORT = 'import'
  const TAB_EXPORT = 'export'
  const TAB_EXPIRED = 'expired'

  const STATUS_PREPAREING = 1
  const STATUS_PRE_PROGRESS = 2
  const STATUS_WAIT_FOR_APPROVED = 3
  const STATUS_APPROVED = 4
  const STATUS_PROGRESS = 5
  const STATUS_SUCCESS = 9
  const STATUS_REJECTED = 8
  const STATUS_ERROR = 11
  const STATUS_PRE_FAIL = 21
  const STATUS_FAIL = 22

  const WITHDRAW_STATUS_PREPAREING = 1
  const WITHDRAW_STATUS_PROGRESS = 2
  const WITHDRAW_STATUS_SUCCESS = 9
  const WITHDRAW_STATUS_ERROR = 11
  const WITHDRAW_STATUS_FAIL = 22

  const STATUS_INSTOCK = 10;
  const STATUS_OUTSTOCK = 20;
  const STATUS_OUT_STOCK_EXPORT = 21;
  const STATUS_EXPIRED = 30;
  const STATUS_STOCK_EXPORT_ISSUE = 22

  const {
    inventoryExternalCodeImportList,
    inventoryExternalCodeWithdrawList,
    inventoryExternalCodeApproved,
    inventoryExternalCodeReject,
    inventoryExpiredSerialList,
  } = inventoryPrivilegeCpcModel()
  const { fetchInventoryHistoryList } = inventoryHistoryModel()
  const { pagination, onPageChange, onFilterEntity } = usePagination()
  const { filters, ordering, onSetValueSearch } = useFilterHeaderTable()
  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal()
  const { resolveDateWithSeperator } = useDate()

  const loading = reactive({
    tableData: false,
  })

  const fields = reactive({
    fieldsDetail: [
      { key: 'ledger_id', label: 'Ledger Id' },
      { key: 'add', label: 'Add Quantity' },
      { key: 'withdraw', label: 'Withdraw' },
      { key: 'issue', label: 'Issue' },
      { key: 'redeem', label: 'Redeem' },
      { key: 'void_issue', label: 'Void Issue' },
      { key: 'void_redeem', label: 'Void Redeem' },
      { key: 'transfer_in', label: 'Transfer In' },
      { key: 'transfer_out', label: 'Transfer Out' },
      { key: 'from_to', label: 'From/To' },
      { key: 'req_identity_name', label: 'Updated By' },
      { key: 'tx_time', label: 'Latest Update' },
    ],
    fieldsImport: [
      { key: 'import_id', label: 'Import Id' },
      { key: 'total_serial', label: 'Total Serial' },
      { key: 'success_serial', label: 'Success' },
      { key: 'error_serial', label: 'Error' },
      { key: 'updatedby_name', label: 'Updated By' },
      { key: 'starttime', label: 'Latest Update' }, // ขาดอยู่
      { key: 'progress', label: 'Progress' },
      { key: 'status', label: 'Status' },
      { key: 'actions', label: '' },
      { key: 'approve_reject', label: '' },
    ],
    fieldsExport: [
      { key: 'withdraw_id', label: 'Withdraw Id' },
      { key: 'withdraw', label: 'Withdraw' },
      { key: 'fullfillment_mode_desc', label: 'Removal Strategy' },
      { key: 'updated_by_name', label: 'Updated By' },
      { key: 'starttime', label: 'Latest Update' }, // ขาดอยู่
      { key: 'progress', label: 'Progress' },
      { key: 'status_withdraw', label: 'Status' },
      { key: 'actions_export', label: '' },
    ],

    fieldsExpired: [
      { key: "no", label: "No." },
      { key: "serial", label: "Serial" },
      { key: "import_id", label: "Import Id" },
      { key: "crm_transaction_ref", label: "Transaction Reference" },
      { key: "createdtime", label: "Created Date"},
      { key: "exp_time", label: "Expire Date" },
      { key: "status", label: "Status" },
    ],
  })

  const inventoryHistoryTable = reactive({
    payload: [],
  })

  const tabs = ref('') // detail , import

  const privilegeDetail = reactive({
    ref: '',
    nameEn: '',
    nameTh: '',
    image: '',
    type: 1,
  })

  const resolveFields = computed(() => ({
    [TAB_DETAIL]: fields.fieldsDetail,
    [TAB_IMPORT]: fields.fieldsImport,
    [TAB_EXPORT]: fields.fieldsExport,
    [TAB_EXPIRED]: fields.fieldsExpired,
  }[tabs.value]))

  const resolveShowTabs = computed(() => privilegeDetail.type == PRIVILEGE_TYPE.CPC)

  const changedTabs = tab => {
    if (tab == TAB_IMPORT) {
      router.replace(`${router.currentRoute.path}?tab=import`).catch(() => { })
    } else if (tab == TAB_EXPORT) {
      router.replace(`${router.currentRoute.path}?tab=export`).catch(() => { })
    } else if (tab == TAB_EXPIRED) {
      router.replace(`${router.currentRoute.path}?tab=expired`).catch(() => { })
    } else {
      router.replace(router.currentRoute.path).catch(() => { })
    }
    tabs.value = tab
  }

  const routeStockDetail = stockRef => {
    router.push(
      `/inventory/privilege/history/group/${router.currentRoute.params.ref
      }/detail/${router.currentRoute.params.invRef
      }${stockRef}`,
    )
  }

  const routeExpiredDetail = expiredRef => {
    router.push(
      `/inventory/privilege/history/group/${router.currentRoute.params.ref
      }/detail/${router.currentRoute.params.invRef
      }${expiredRef}`,
    )
  }

  const routeImportDetail = importRef => {
    router.push(
      `/inventory/privilege/history/group/${router.currentRoute.params.ref
      }/detail/${router.currentRoute.params.invRef
      }${importRef}`,
    )
  }

  const fetchHistoryDetail = (showLoading = true, loadPrivilege = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    inventoryHistoryTable.payload = []
    fetchInventoryHistoryList.payload.Privilege_Id = router.currentRoute.params.ref
    fetchInventoryHistoryList.payload.Inventory_Id = router.currentRoute.params.invRef
    fetchInventoryHistoryList.payload.Page = pagination.currentPage
    fetchInventoryHistoryList.payload.Limit = pagination.perPage
    fetchInventoryHistoryList.payload.Filters = filters
    fetchInventoryHistoryList.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', fetchInventoryHistoryList)
      .then(response => {
        inventoryHistoryTable.payload = response.data.paylaod.ledger_history
        pagination.rows = response.data.paylaod.ledger_history.length
        pagination.totalRows = response.data.filtered_record
        if (loadPrivilege) {
          privilegeDetail.ref = response.data.paylaod.privilege_reference
          privilegeDetail.nameEn = response.data.paylaod.privilege_name_en
          privilegeDetail.nameTh = response.data.paylaod.privilege_name_th
          privilegeDetail.image = response.data.paylaod.privilege_image_url
          privilegeDetail.type = response.data.paylaod.privilege_type
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  const fetchHistoryImport = (showLoading = true, loadPrivilege = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    inventoryHistoryTable.payload = []
    inventoryExternalCodeImportList.payload.Privilege_Id = router.currentRoute.params.ref
    inventoryExternalCodeImportList.payload.Inventory_Id = router.currentRoute.params.invRef
    inventoryExternalCodeImportList.payload.Page = pagination.currentPage
    inventoryExternalCodeImportList.payload.Limit = pagination.perPage
    inventoryExternalCodeImportList.payload.Filters = filters
    inventoryExternalCodeImportList.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', inventoryExternalCodeImportList)
      .then(response => {
        inventoryHistoryTable.payload = response.data.paylaod.import_list
        pagination.rows = response.data.paylaod.import_list.length
        pagination.totalRows = response.data.filtered_record
        if (loadPrivilege) {
          privilegeDetail.ref = response.data.paylaod.privilege_reference
          privilegeDetail.nameEn = response.data.paylaod.privilege_name_en
          privilegeDetail.nameTh = response.data.paylaod.privilege_name_th
          privilegeDetail.image = response.data.paylaod.privilege_image_url
          privilegeDetail.type = response.data.paylaod.privilege_type
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  const fetchHistoryExport = (showLoading = true, loadPrivilege = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    inventoryHistoryTable.payload = []
    inventoryExternalCodeWithdrawList.payload.Privilege_Id = router.currentRoute.params.ref
    inventoryExternalCodeWithdrawList.payload.Inventory_Id = router.currentRoute.params.invRef
    inventoryExternalCodeWithdrawList.payload.Page = pagination.currentPage
    inventoryExternalCodeWithdrawList.payload.Limit = pagination.perPage
    inventoryExternalCodeWithdrawList.payload.Filters = filters
    inventoryExternalCodeWithdrawList.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', inventoryExternalCodeWithdrawList)
      .then(response => {
        inventoryHistoryTable.payload = response.data.paylaod.withdraw_list
        pagination.rows = response.data.paylaod.withdraw_list.length
        pagination.totalRows = response.data.filtered_record
        if (loadPrivilege) {
          privilegeDetail.ref = response.data.paylaod.privilege_reference
          privilegeDetail.nameEn = response.data.paylaod.privilege_name_en
          privilegeDetail.nameTh = response.data.paylaod.privilege_name_th
          privilegeDetail.image = response.data.paylaod.privilege_image_url
          privilegeDetail.type = response.data.paylaod.privilege_type
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }
  const fetchHistoryExpired = (showLoading = true, loadPrivilege = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    let payload = {
      Inventory_Id: router.currentRoute.params.invRef,
      Privilege_Id: router.currentRoute.params.ref,
      Page: pagination.currentPage,
      Limit: pagination.perPage,
      Filters: filters,
      Ordering: ordering.value,
    };
    inventoryExpiredSerialList.payload = payload;

    inventoryHistoryTable.payload = []
    store
      .dispatch('api/apiRequest', inventoryExpiredSerialList)
      .then(response => {
        inventoryHistoryTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  const exportFile = file => {
    if (!file) return
    window.location.href = file
  }

  const importApprove = importId => {
    inventoryExternalCodeApproved.payload.Import_Id = importId
    store
      .dispatch('api/apiRequest', inventoryExternalCodeApproved)
      .then(response => {
        openSuccessModal(
          'ทำรายการสำเร็จ !',
          null,
          'ตกลง',
          () => fetchHistoryImport(true, false),
          () => fetchHistoryImport(true, false),
        )
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  const importReject = importId => {
    inventoryExternalCodeReject.payload.Import_Id = importId
    store
      .dispatch('api/apiRequest', inventoryExternalCodeReject)
      .then(response => {
        openSuccessModal(
          'ทำรายการสำเร็จ !',
          null,
          'ตกลง',
          () => fetchHistoryImport(true, false),
          () => fetchHistoryImport(true, false),
        )
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  const checkRouteImportDetail = () => {
    if (router.currentRoute.query.tab) {
      tabs.value = router.currentRoute.query.tab
    } else {
      tabs.value = TAB_DETAIL
    }
  }

  const checkFetchByTabs = () => {
    switch (tabs.value) {
      case TAB_DETAIL:
        fetchHistoryDetail(true, true)
        break
      case TAB_IMPORT:
        fetchHistoryImport(true, true)
        break
      case TAB_EXPORT:
        fetchHistoryExport(true, true)
        break
      case TAB_EXPIRED:
        fetchHistoryExpired(true, true)
        break
      default:
        break
    }
  }

  const resolveImportStatusLabel = status => {
    switch (status) {
      case STATUS_PREPAREING:
        return 'Preparing'
      case STATUS_PRE_PROGRESS:
        return 'Pre Progress'
      case STATUS_WAIT_FOR_APPROVED:
        return 'Wait for approve'
      case STATUS_APPROVED:
        return 'Approved'
      case STATUS_PROGRESS:
        return 'Progress'
      case STATUS_SUCCESS:
        return 'Complete'
      case STATUS_REJECTED:
        return 'Rejected'
      case STATUS_ERROR:
        return 'Error'
      case STATUS_PRE_FAIL:
        return 'Pre Fail'
      case STATUS_FAIL:
        return 'Fail'
      default:
        return 'None'
    }
  }

  const resolveImportStatusClass = status => {
    switch (status) {
      case STATUS_PREPAREING:
        return '#FFB200'
      case STATUS_PRE_PROGRESS:
        return '#CCDBE2'
      case STATUS_WAIT_FOR_APPROVED:
        return '#D9CBFF'
      case STATUS_APPROVED:
        return '#7642FF'
      case STATUS_PROGRESS:
        return '#CDE6CD'
      case STATUS_SUCCESS:
        return '#00A400'
      case STATUS_REJECTED:
        return '#F5C0C6'
      case STATUS_ERROR:
        return '#B40000'
      case STATUS_PRE_FAIL:
        return '#F5C0C6'
      case STATUS_FAIL:
        return '#B40000'
      default:
        return '#B40000'
    }
  }

  const resolveExportStatusLabel = status => {
    switch (status) {
      case WITHDRAW_STATUS_PREPAREING:
        return 'Preparing'
      case WITHDRAW_STATUS_PROGRESS:
        return 'Progress'
      case WITHDRAW_STATUS_SUCCESS:
        return 'Complete'
      case WITHDRAW_STATUS_ERROR:
        return 'Error'
      case WITHDRAW_STATUS_FAIL:
        return 'Fail'
      default:
        return 'None'
    }
  }

  const resolveExportStatusClass = status => {
    switch (status) {
      case WITHDRAW_STATUS_PREPAREING:
        return '#FFB200'
      case WITHDRAW_STATUS_PROGRESS:
        return '#CDE6CD'
      case WITHDRAW_STATUS_SUCCESS:
        return '#00A400'
      case WITHDRAW_STATUS_ERROR:
        return '#B40000'
      case WITHDRAW_STATUS_FAIL:
        return '#B40000'
      default:
        return '#B40000'
    }
  }

  const resolveStockStatusLabel = (status) => {
    switch (status) {
      case STATUS_INSTOCK:
        return "In stock";
      case STATUS_OUTSTOCK:
        return "Out stock";
      case STATUS_OUT_STOCK_EXPORT:
        return "Export";
      case STATUS_EXPIRED:
        return "Expired";
      case STATUS_STOCK_EXPORT_ISSUE:
        return "Export Issue";
      default:
        return "None";
    }
  };

  const resolveStockStatusClass = (status) => {
    switch (status) {
      case STATUS_INSTOCK:
        return "in-stock";
      case STATUS_OUTSTOCK:
        return "out-stock";
      case STATUS_OUT_STOCK_EXPORT:
        return "out-export";
      case STATUS_EXPIRED:
        return "expired";
      case STATUS_STOCK_EXPORT_ISSUE:
        return "Export-Issue";
      default:
        return "None";
    }
  };

  watch(
    tabs,
    () => {
      if (pagination.currentPage != 1) {
        pagination.currentPage = 1
      } else {
        checkFetchByTabs()
      }
    },
    { deep: true },
  )

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        checkFetchByTabs()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      if (!loading.tableData) {
        pagination.currentPage = 1

        checkFetchByTabs()
      }
    },
    { deep: true },
  )

  onBeforeMount(() => {
    checkRouteImportDetail()
  })

  return {
    TAB_DETAIL,
    TAB_IMPORT,
    TAB_EXPORT,
    TAB_EXPIRED,
    STATUS_PREPAREING,
    STATUS_PRE_PROGRESS,
    STATUS_SUCCESS,
    STATUS_WAIT_FOR_APPROVED,

    resolveFields,
    loading,
    inventoryHistoryTable,
    privilegeDetail,
    resolveShowTabs,
    tabs,
    pagination,

    changedTabs,
    resolveImportStatusLabel,
    resolveImportStatusClass,
    resolveExportStatusLabel,
    resolveExportStatusClass,
    resolveStockStatusLabel,
    resolveStockStatusClass,

    routeStockDetail,
    routeImportDetail,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    exportFile,
    importApprove,
    importReject,
    routeExpiredDetail,

  }
}
